// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { IReferenceToken } from './IReferenceToken';
import {
    IReferenceTokenFromJSON,
    IReferenceTokenFromJSONTyped,
    IReferenceTokenToJSON,
    IReferenceTokenToJSONTyped,
} from './IReferenceToken';

/**
 * 
 * @export
 * @interface IAccountInfo
 */
export interface IAccountInfo {
    /**
     * 
     * @type {IReferenceToken}
     * @memberof IAccountInfo
     */
    token?: IReferenceToken;
}

/**
 * Check if a given object implements the IAccountInfo interface.
 */
export function instanceOfIAccountInfo(value: object): value is IAccountInfo {
    return true;
}

export function IAccountInfoFromJSON(json: any): IAccountInfo {
    return IAccountInfoFromJSONTyped(json, false);
}

export function IAccountInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): IAccountInfo {
    if (json == null) {
        return json;
    }
    return {
        
        'token': json['token'] == null ? undefined : IReferenceTokenFromJSON(json['token']),
    };
}

export function IAccountInfoToJSON(json: any): IAccountInfo {
    return IAccountInfoToJSONTyped(json, false);
}

export function IAccountInfoToJSONTyped(value?: IAccountInfo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'token': IReferenceTokenToJSON(value['token']),
    };
}

